import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  NotificationMessage,
  NotificationsQueue,
} from '@/components/Notifications';
import { Endpoint, QueryKey } from '@/constants';
import { postData } from '@/utils/postData';

export const useUpdateAddress = () => {
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: postData(Endpoint.UpdateDeliveryAddress),
    onSuccess: data => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.StoredDeliveryAddresses],
      });
      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={!data.isSuccess}>
              {data.messages[0]}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );
    },
  });

  return { isPending, updateAddress: mutate };
};
